import { ACCESS_TOKEN_SAFETY_MARGIN_SECONDS } from './authConstants';
import { getJwtExpUnixFromToken } from './jwtCookieHelpers';

/** true — токена нет, не удалось прочитать exp, или до exp осталось ≤ safety margin */
export function isAccessTokenExpiredOrNearExpiry(
  token,
  clockDeltaSeconds = 0,
  safetyMarginSeconds = ACCESS_TOKEN_SAFETY_MARGIN_SECONDS,
) {
  if (!token) {
    return true;
  }

  const exp = getJwtExpUnixFromToken(token);
  if (exp == null) {
    return false;
  }

  const adjustedNow = Math.floor(Date.now() / 1000) + clockDeltaSeconds;

  return adjustedNow >= exp - safetyMarginSeconds;
}
